import React from "react";
import * as styles from "../time/time.module.scss";

/**
 * @type {Object} 「UI:atoms - タイム 投稿日・最終更新日 記事用 コンポーネント」DOMです。
 * @return {Object} DOMを返します。
 * @param {Array} props コンポーネントを受け取るための引数です。コンポーネントに任意の値を渡します。（ref.https://ja.react.dev/learn/passing-props-to-a-component）
 * @param {Int} props.number 読了時間として設定した整数を受け取るための引数です。
 *
 */

const Read = (props) => {
  return <p className={`${styles.read}`}>読了目安 : {props.number}分</p>;
};

export default Read;
